import styled from 'styled-components'
import { desktopVw } from '../../styles/utils'

const FormFooter = styled.div`
  margin: 2.4rem 0;

  p {
    text-align: center;
    font-size: 16px;
    line-height: 22px;
    font-family: ${props => props.theme.fonts.grosa};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  a {
    text-decoration: underline;
    text-underline-offset: 3px;
    letter-spacing: 1px;
    font-family: ${props => props.theme.fonts.grosa};
    font-size: 14px;
    line-height: 20px;
    text-transform: uppercase;
    font-weight: 500;
    margin: 8px 0 0 0;
  }

  @media (min-width: ${props => props.theme.breakpoints.desktopSmall}px) {
    margin-top: ${desktopVw(20)};

    p {
      font-size: ${desktopVw(16)};
      line-height: ${desktopVw(22)};
      flex-direction: row;
    }

    a {
      margin: 0 0 0 10px;
      font-size: ${desktopVw(14)};
    }
  }
`

export default FormFooter
